// Meta (Facebook) Pixel event helpers.
// The base snippet + init + initial PageView live in public/index.html <head>
// (reads REACT_APP_META_PIXEL_ID at build time). These helpers no-op if the
// pixel was not initialized (window.fbq undefined).

export function trackPageView() {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'PageView');
}

export function trackEvent(name, params) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', name, params || {});
}

// Fires an event at most once per browser session (dedupe by key).
export function trackEventOnce(name, params, key) {
  if (typeof window === 'undefined' || !window.fbq) return;
  const k = `bm_px_${key || name}`;
  try {
    if (sessionStorage.getItem(k)) return;
    sessionStorage.setItem(k, '1');
  } catch (_) { /* ignore storage errors */ }
  window.fbq('track', name, params || {});
}
